import AppIcons from "../../../components/Base/AppIcons";
import { NOMBRE_PLATAFORMA } from "../../../utils/constants";
import { URL_PASARELA_ASIGNACION_QR } from "../routes_backend";
import CodeQrA from "./Base/CodeQrA";
import CodeQrB from "./Base/CodeQrB";
import WithCodeQrPse from "./viewsHigherOrder/WithCodeQrPse";

const CodeQr =
  process.env.REACT_APP_APPENV_NAME === NOMBRE_PLATAFORMA.PDP
    ? CodeQrA
    : CodeQrB;

export const routesCodeQr = [
  {
    link: "/info/pasarela-asignacion-qr--code-qr",
    label: (
      <AppIcons
        Logo={"RECAUDO_CODIGO_DE_BARRAS"}
        name="Descargar Código QR PSE"
      />
    ),
    component: () => WithCodeQrPse(CodeQr, URL_PASARELA_ASIGNACION_QR.CODE_QR),
    permission: [901],
  },
];
